<ng-container>
  <label
    [for]="name() + '-' + value()"
    class="wrapper"
    [ngClass]="{ active: isActive() }"
    [tabindex]="name() + '-checkbox'"
    (click)="controller()"
    (keydown)="onKeyDown($event)">
    <orbit-checkbox
      [type]="type()"
      [name]="name()"
      [id]="name() + '-' + value()"
      [value]="value()"
      [controller]="controller()" />
    <div class="extended-text">
      <div class="description">{{ item() }}</div>
      <div class="details">{{ description() }}</div>
      <div class="details">{{ subtitle() }}</div>
    </div>

    <!-- ★ star toggle (optional) -->
    @if (showFavorite()) {
      <button
        [title]="isFavorite() ? titleForUnFavorite() : titleForFavorite()"
        type="button"
        class="favorite-btn"
        (click)="onFavoriteClick($event)">
        @if (isFavorite()) {
          <orbit-fa-icon [ngClass]="'default-star filled'" [iconName]="star" />
        } @else {
          <orbit-fa-icon [ngClass]="'default-star'" [iconName]="star" />
        }
      </button>
    }
  </label>
</ng-container>
